export interface ThemeSection {
  [key: string]: string; // background, text, etc.
}

export interface ThemeConfig {
  isActive: boolean;
  theme: {
    [section: string]: ThemeSection;
  };
}

export function applyTheme(config?: ThemeConfig | null): void {
  const root = document.documentElement;

  // Si no hay theme o no está activo → eliminar variables anteriores
  if (!config || !config.theme.isActive) {
    root.removeAttribute("data-theme-active");
    // Opcional: limpiar variables previas
    Array.from(root.style).forEach((prop) => {
      if (prop.startsWith("--login-") || prop.startsWith("--language-switch-")) {
        root.style.removeProperty(prop);
      }
    });
    return;
  }

  const theme = config.theme;

  console.log(theme);

  // Marca el documento como "theme activo"
  root.setAttribute("data-theme-active", "true");

  Object.keys(theme).forEach((section) => {
    const sectionTheme = theme[section];
    Object.keys(sectionTheme).forEach((key) => {
      // convierte camelCase a kebab-case
      const cssVar = `--${section}-${key.replace(/([A-Z])/g, "-$1").toLowerCase()}`;
      const value = sectionTheme[key];
     
      // Aplica la variable con prioridad
      root.style.setProperty(cssVar, value, "important");
    });
  });
}


